import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Inject, Model } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import FloatPortal from "../../../../../../lib/comps/Portal/FloatPortal";
import { clamp } from "lodash-es";
import { copyComponentStylesToClipBoard } from "../../../../../../lib/designer/utils/copyAndPasteComponent";
const MENU_ADD_KEY = '____add';
let TextTooltip = class TextTooltip extends Vue {
  render() {
    const h = arguments[0];
    return h("div", {
      "style": "position: relative;"
    }, [h("div", {
      "class": "uc-inputbox-reset-button"
    }, [this.$slots.icon]), h(FloatPortal, {
      "class": "uc-inputbox-reset-tip"
    }, [h("div", {
      "class": "uc-inputbox-reset-tip-portal"
    }, [this.$slots.title])])]);
  }
};
TextTooltip = __decorate([Component({
  name: 'TextTooltip'
})], TextTooltip);
export { TextTooltip };
let DropDownWithAddInput = class DropDownWithAddInput extends Vue {
  constructor() {
    super(...arguments);
    this.internalVisible = false;
    this.inputTemp = '';
  }
  submit() {
    this.$emit('add', this.inputTemp, () => this.inputTemp = '');
  }
  renderAddMenu() {
    const h = this.$createElement;
    return h("a-menu-item", {
      "key": MENU_ADD_KEY,
      "class": "ucdProps-cssSelector-addSelectorMenu"
    }, [h("a-input", _mergeJSXProps([{
      "class": "ucdProps-cssSelector-addSelectorMenu-selectorInput",
      "attrs": {
        "size": "small",
        "placeholder": "自定义"
      },
      "style": {
        width: `${clamp(this.inputTemp.length, 5, 20) + 3}ch`
      },
      "on": {
        "pressEnter": this.submit
      }
    }, {
      "on": {
        'change.value': ev => this.$emit('change', {
          selector: ev
        })
      }
    }, {
      "model": {
        value: this.inputTemp,
        callback: $$v => {
          this.inputTemp = $$v;
        }
      }
    }])), !this.inputTemp ? h("a-tooltip", {
      "attrs": {
        "overlayStyle": {
          'pointer-events': 'none'
        },
        "mouseLeaveDelay": 0
      }
    }, [h("div", {
      "slot": "title"
    }, [this.$slots.tooltip]), h("i", {
      "class": "fa fa-question-circle ucdProps-cssSelector-addSelectorMenu-tooltipIcon"
    })]) : null, this.inputTemp ? h("a-button", {
      "class": "ucdProps-cssSelector-addSelectorMenu-submitButton",
      "attrs": {
        "size": "small"
      },
      "on": {
        "click": this.submit
      }
    }, ["\u6DFB\u52A0"]) : null]);
  }
  render() {
    const h = arguments[0];
    return h("a-dropdown", {
      "model": {
        value: this.internalVisible,
        callback: $$v => {
          this.internalVisible = $$v;
        }
      }
    }, [h("div", {
      "on": {
        "click": () => {
          this.internalVisible = true;
        }
      }
    }, [this.$slots.trigger]), h("a-menu", {
      "slot": "overlay",
      "on": {
        "click": ev => {
          if (ev.key !== MENU_ADD_KEY) {
            this.internalVisible = false;
          }
        }
      }
    }, [this.$slots.menuItems, this.renderAddMenu()])]);
  }
};
DropDownWithAddInput = __decorate([Component({
  name: 'DropDownWithAddInput'
})], DropDownWithAddInput);
let CSSSelector = class CSSSelector extends Vue {
  get stylePanelState() {
    return this.uc.designer.stylePanelState;
  }
  handleHover(payload) {
    var _payload$selector;
    this.stylePanelState.highlightSelectedRegion({
      selector: (_payload$selector = payload.selector) === null || _payload$selector === void 0 ? void 0 : _payload$selector.selector
    });
    this.$emit('hoverItem', payload);
  }
  renderMenuItem(item, onClick, onDelete, onHover) {
    const h = this.$createElement;
    onHover = onHover || (() => undefined);
    return h("a-menu-item", {
      "slot": "menuItems",
      "class": "ucdProps-cssSelector-selectorMenu",
      "on": {
        "click": onClick,
        "mouseenter": onHover
      }
    }, [item.name, item.custom ? h("div", {
      "class": "ucdProps-cssSelector-selectorMenu-deleteIcon",
      "on": {
        "click": ev => {
          ev.stopPropagation();
          onDelete();
        }
      }
    }, [h("i", {
      "class": "fa fa-trash"
    })]) : null]);
  }
  renderSelect() {
    var _stylePanelState$curr, _stylePanelState$curr2;
    const h = this.$createElement;
    const {
      stylePanelState
    } = this;
    const allSelector = stylePanelState.selectors;
    const allPseudoClasses = stylePanelState.pseudoClasses;
    return h("div", {
      "class": "ucdProps-cssSelector-dropdownBox"
    }, [h(DropDownWithAddInput, {
      "on": {
        "add": async (input, clearInputCb) => {
          if (/^[0-9]*$/.test(input)) {
            this.$message.warning('选择器名不能是纯数字');
            return;
          }
          await stylePanelState.addSelectorOrPseudo({
            selector: input
          });
          stylePanelState.currentSelector = input;
          clearInputCb();
        },
        "change": ev => this.handleHover({
          selector: ev
        })
      }
    }, [h("div", {
      "slot": "trigger"
    }, [(_stylePanelState$curr = stylePanelState.currentSelectorInfo) === null || _stylePanelState$curr === void 0 ? void 0 : _stylePanelState$curr.name]), h("div", {
      "slot": "tooltip"
    }, ["\u53EF\u4EE5\u586B\u5199css\u9009\u62E9\u5668\uFF0C\u5982\uFF1A.className\u3001#id \u5BF9\u7EC4\u4EF6\u5B50\u5143\u7D20\u8FDB\u884C\u9009\u62E9"]), allSelector.map(item => this.renderMenuItem(item, () => stylePanelState.currentSelector = item.selector, () => stylePanelState.deleteExtraStyles({
      selector: item.selector,
      pseudo: false
    }), () => this.handleHover({
      selector: item
    })))]), h("div", {
      "class": "ucdProps-cssSelector-divider"
    }, [" > "]), h(DropDownWithAddInput, {
      "on": {
        "add": async (input, clearInputCb) => {
          if (/^[0-9]*$/.test(input)) {
            this.$message.warning('伪类名不能是纯数字');
            return;
          }
          await stylePanelState.addSelectorOrPseudo({
            pseudo: input
          });
          stylePanelState.currentPseudoClass = input;
          clearInputCb();
        }
      }
    }, [h("div", {
      "slot": "trigger"
    }, [(_stylePanelState$curr2 = stylePanelState.currentPseudoClassInfo) === null || _stylePanelState$curr2 === void 0 ? void 0 : _stylePanelState$curr2.name]), h("div", {
      "slot": "tooltip"
    }, ["\u53EF\u4EE5\u586B\u5199css\u4F2A\u7C7B\u9009\u62E9\u5668\uFF0C\u5982 &:focus \u9F20\u6807\u7126\u70B9, &:active \u9F20\u6807\u9009\u4E2D"]), allPseudoClasses.map(item => this.renderMenuItem(item, () => stylePanelState.currentPseudoClass = item.selector, () => stylePanelState.deleteExtraStyles({
      pseudo: item.selector
    }), () => this.handleHover({})))])]);
  }
  renderTooltip() {
    const h = this.$createElement;
    return h("div", {
      "class": "ucdProps-cssSelector-tooltipBox"
    }, [h(TextTooltip, [h("i", {
      "slot": "icon",
      "class": "fa fa-info-circle",
      "attrs": {
        "aria-hidden": "true"
      }
    }), h("div", {
      "slot": "title"
    }, ['选择组件内部元素 > 选择伪类'])])]);
  }
  renderAdvancedToggle() {
    const h = this.$createElement;
    if (!this.stylePanelState.isRootSelector) return;
    return h("div", {
      "class": ['ucdProps-cssSelector-advancedToggle', this.enableAdvancedSetting && 'isActive'],
      "on": {
        "click": () => {
          this.$emit('change', !this.enableAdvancedSetting);
          if (!this.enableAdvancedSetting) this.$emit('changeExpanded', true);
        }
      }
    }, [h("div", [h("i", {
      "class": "fa fa-code",
      "attrs": {
        "aria-hidden": "true"
      }
    })])]);
  }
  renderCopyStyles() {
    const h = this.$createElement;
    const handleClick = () => {
      copyComponentStylesToClipBoard(this.designer);
      this.uc.$message.success('已复制组件样式', 0.5);
    };
    return h("div", {
      "class": "ucdProps-cssSelector-tooltipBox"
    }, [h(TextTooltip, [h("i", {
      "slot": "icon",
      "on": {
        "click": handleClick
      },
      "class": "fa fa-clipboard",
      "attrs": {
        "aria-hidden": "true"
      }
    }), h("div", {
      "slot": "title"
    }, ['复制样式'])])]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucdProps-cssSelector"
    }, [h("div", {
      "class": "ucdProps-cssSelector-leftTitle",
      "on": {
        "click": ev => ev.stopPropagation()
      }
    }, [this.renderSelect(), this.renderTooltip(), this.renderCopyStyles(), this.renderAdvancedToggle()]), h("div", {
      "class": "ucdProps-cssSelector-rightTitle"
    }, ["\u81EA\u5B9A\u4E49CSS"])]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_BUS
})], CSSSelector.prototype, "uc", void 0);
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], CSSSelector.prototype, "designer", void 0);
__decorate([Model('change', {
  type: Boolean
})], CSSSelector.prototype, "enableAdvancedSetting", void 0);
CSSSelector = __decorate([Component({
  name: 'CSSSelector'
})], CSSSelector);
export { CSSSelector };
//# sourceMappingURL=index.js.map
